import { registerPostalCheck } from '../../../assets/js/helpers/postalCheck.js';
import docReady from '../../../assets/js/docReady.js';
import { registerBarChart, registerLineChart } from '../../shared/priceChart/priceChart.js';
import { tryResumeOrderFlow } from '../../../assets/js/helpers/orderFlow.js';
import { clickableTable, scrollableTable } from '../../../assets/js/helpers/table.js';
import { registerNetOperatorCheck } from './../../shared/netOperatorCheck/netOperatorCheck.js';
import { registerImageLightbox } from '../../shared/imageSlideshow/imageSlideshow.js';

function loadPostalCheck() {
    const postalChecks = Array.from(document.querySelectorAll('.postal-check-component:not(.net-operator-check-component)'));

    postalChecks.forEach((postalCheck) => {
        registerPostalCheck(postalCheck);
    });
}

docReady(() => {
    loadPostalCheck();
    registerBarChart();
    registerLineChart();
    registerNetOperatorCheck();
    registerImageLightbox();

    document.querySelectorAll('.table-container').forEach((tableElement) => {
        scrollableTable(tableElement);
        clickableTable(tableElement);
    });
});

tryResumeOrderFlow();
